module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "Golden-Gate-Bridge-San-Francisco.e4f43801.png";